<div class="home-container">

  <main class="main-content">
    <div class="container">
      <div class="content-wrapper">
        <aside class="sidebar-container">
          <app-sidebar (categorySelected)="onCategorySelected($event)"
                       (ratingSelected)="onRatingSelected($event)"
                       (maxPriceSelected)="onPriceChange($event)"></app-sidebar>
        </aside>

        <section class="products-section">
          <div class="section-header">
            <h1>{{ 'HOME.PRODUCTS_TITLE' | translate }}</h1>
            <div class="sort-options">
                <select
                        id="sortSelect"
                        class="sort-select"
                        [ngModel]="sortOption()"
                        (ngModelChange)="onSortChange($event)">
                    <option value="priceLowHigh">{{ 'HOME.SORT_LOW_HIGH' | translate }}</option>
                    <option value="priceHighLow">{{ 'HOME.SORT_HIGH_LOW' | translate }}</option>
                    <option value="ratingHighLow">{{ 'HOME.SORT_RATING' | translate }}</option>
                    <option value="nameAZ">{{ 'HOME.SORT_NAME' | translate }}</option>
                </select>
            </div>
          </div>

          <div class="products-grid">
            @for (product of filteredProducts(); track product){
              <app-product-card
                      [product]="product"
                     >
              </app-product-card>
            }

          </div>

          <div class="load-more">
            <button class="load-more-btn">{{ 'HOME.LOAD_MORE' | translate }}</button>
          </div>
        </section>
      </div>
    </div>
  </main>
</div>

